import { Wallet, TrendingUp, TrendingDown, Scale } from "lucide-react";
import { KpiCard } from "./KpiCard";
import type { MonthlyComparison } from "@/hooks/use-dashboard-analytics";

interface DashboardKpiHeaderProps {
  totalBalance: number;
  monthlyComparison: MonthlyComparison;
  formatCurrency: (value: number) => string;
  isLoading?: boolean;
}

export function DashboardKpiHeader({
  totalBalance,
  monthlyComparison,
  formatCurrency,
  isLoading,
}: DashboardKpiHeaderProps) {
  if (isLoading) {
    return (
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="h-[88px] bg-muted/50 rounded-lg animate-pulse" />
        ))}
      </div>
    );
  }

  const {
    currentMonthIncome,
    currentMonthExpenses,
    incomePercentageChange,
    percentageChange,
  } = monthlyComparison;

  const netBalance = currentMonthIncome - currentMonthExpenses;

  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
      <KpiCard
        label="Saldo Total"
        value={formatCurrency(totalBalance)}
        icon={Wallet}
        colorClass="text-primary"
      />
      <KpiCard
        label="Receitas"
        value={formatCurrency(currentMonthIncome)}
        trend={{ percentage: incomePercentageChange, positiveIsGood: true }}
        icon={TrendingUp}
        colorClass="text-success"
      />
      <KpiCard
        label="Despesas"
        value={formatCurrency(currentMonthExpenses)}
        trend={{ percentage: percentageChange, positiveIsGood: false }}
        icon={TrendingDown}
        colorClass="text-destructive"
      />
      <KpiCard
        label="Saldo do Mes"
        value={formatCurrency(netBalance)}
        icon={Scale}
        colorClass={netBalance >= 0 ? "text-success" : "text-destructive"}
      />
    </div>
  );
}
